import Nav from "./components/Nav";
import Hero from "./components/Hero";
import ThePlace from "./components/ThePlace";
import Experiences from "./components/Experiences";
import Stay from "./components/Stay";
import Restore from "./components/Restore";
import TasteSeasons from "./components/TasteSeasons";
import BookYourStay from "./components/BookYourStay";
import AlpineEffects from "./components/AlpineEffects";

export default function Home() {
  return (
    <main className="relative bg-background-50 text-foreground-950">
      <AlpineEffects />
      <Nav />
      <Hero />
      <ThePlace />
      <Experiences />
      <Stay />
      <Restore />
      <TasteSeasons />
      <BookYourStay />
    </main>
  );
}